<app-common-country-hero [heroData]="heroHeader"></app-common-country-hero>
<ng-container *ngIf="pageData?.customersStatsContentPanel">
  <app-local-trusted-way-section
    [pageData]="pageData"
  ></app-local-trusted-way-section>
  <app-benefits-section [pageData]="pageData"></app-benefits-section>
  <app-video-section [pageData]="pageData"></app-video-section>
  <app-form-section [pageData]="pageData"></app-form-section>
</ng-container>
<ng-container *ngIf="!pageData?.customersStatsContentPanel">
  <app-form-section [pageData]="pageData"></app-form-section>
  <app-benefits-section [pageData]="pageData"></app-benefits-section>
  <app-video-section [pageData]="pageData"></app-video-section>
</ng-container>
<app-features-section [pageData]="pageData"></app-features-section>
<app-common-subproducts-whitepaper
  [whitePaperData]="whitePaperData"
></app-common-subproducts-whitepaper>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
<!-- <app-local-regulated></app-local-regulated>
<app-products-container></app-products-container>
<app-why-verto-local></app-why-verto-local>
<app-homepage-security-local></app-homepage-security-local>
<app-currency-list-local></app-currency-list-local>
<app-common-latest-news [blogData]="newsList" [isWhiteBg]="true"></app-common-latest-news>
<app-local-subscribe-newsroom></app-local-subscribe-newsroom>
<app-common-getstarted [getStartedData]="getStartedData"></app-common-getstarted> -->
<!-- <app-api-design-container></app-api-design-container> -->
